import React, { Component } from 'react';
import {Link} from 'react-router-dom'


//审查超纲-tablist
export const tabList = [{
	name: '进行中',
	key: 'checking',
	index:0
}, {
	name: '审查完成',
	key: 'check_finish',
	index:1
}, {
	name: '入库中',
	key: 'online_ing',
	index:2
}, {
	name: '已入库',
	key: 'online',
	index:3
}]

//审查超纲-列表
export const tableColumns = [{
  title: '任务ID',
  dataIndex:'task_id',
  key: 'task_id',
  width:80,
  index:1,
}, {
  title: '任务名',
  	dataIndex: 'name_able',
  	key: 'name_able',
  	index:2,
  	render: (text, record) => {
  		return <Link to={`/questionmanage/checkBeyondLevel/detail/${record.task_id}`}>{text}</Link>;
  	}
}, {
  title: '任务名',
  	dataIndex: 'name_unable',
  	key: 'name_unable',
  	index:3,
}, {
  title: '审查人',
  key: 'check_user_name',
  dataIndex: 'check_user_name',
  width:80,
  index:4,
 
}, {
  title: '删关联/改关联/总题',
  key: 'question_count',
  dataIndex: 'question_count',
  width:120,
  render:(text,record)=>{
  		return <span>{record.question_count_del_relate}/{record.question_count_move}/{record.question_count}</span>
  },
  index:5,
},{
  title: '入库时间',
  key: 'online_time',
  dataIndex: 'online_time',
  width:150,
  index:6,
},{
  title: '完成时间/截止时间',
  key: 'finish_time',
  width:150,
  index:7,
  render:(text,record)=>{
  		return <span><div>{record.finish_time.split('/')[0]}</div><div>{record.finish_time.split('/')[1]}</div></span>
  },
  dataIndex: 'finish_time/dead_time',
},{
  title: '创建时间',
  key: 'create_time',
  dataIndex: 'create_time',
  width:150,
  index:8,
}];


//题型枚举
export const questionTypeList = [{
	name: '全部',
	key: 'all',
}, {
	name: '填空题',
	key: '20',
}, {
	name: '选择题',
	key: '21',
}, {
	name: '判断题',
	key: '25',
}, {
	name: '选词填空',
	key: '22',
}, {
	name: '图片挖空',
	key: '28',
}, {
	name: '连线题',
	key: '31',
}, {
	name: '分类题',
	key: '32',
}, {
	name: '应用题',
	key: '30',
}, {
	name: '竖式题',
	key: '35',
}, {
	name: '脱式题',
	key: '49',
}]


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/check_beyond_level/constData/index.js